import React, { PureComponent } from 'react';
import WebGLPointsLayer from 'ol/layer/WebGLPoints';
import GeoJSON from 'ol/format/GeoJSON';
import VectorSource from 'ol/source/Vector.js';
import { withTimezone } from '@ro-utils/common/radar-params';
import { removeLayer, removeLayerByClassName } from '@ro-utils/common/helpers';
import { RADAR_FORMAT } from '@ro-utils/constant';

import moment from 'moment';
import Icon from '@ro-atoms/Icon';
import { getHour } from '@ro-sources/calendar';
import { setLayerOpacity, getTimeDiff } from '@ro-utils/common/helpers';
import { Legend, LegendInner, LegendBadge } from './Lightnings.styles';

import { strike } from './strike';

import { LAYER_DETECTOR, LIGHTNINGS_DATEFORMAT } from '@ro-utils/constant';

class Lightnings extends PureComponent {
  state = {
    animation: true
  };
  get colorRange() {
    const { palette, interpolation } = this.props;
    return palette.length > 1 ? [...palette] : interpolation;
  }
  lightningsTimeouts = [];
  shouldComponentUpdate(nextProps) {
    const {
      strikes,
      palette,
      date,
      settings: { opacity, pointSize }
    } = this.props;

    const {
      strikes: newStrikes,
      settings: { opacity: newOpacity, pointSize: newPointSize },
      palette: newPalette,
      date: newDate
    } = nextProps;

    const valid = [
      JSON.stringify(strikes) !== JSON.stringify(newStrikes),
      opacity !== newOpacity,
      pointSize !== newPointSize,
      palette[0] !== newPalette[0] || palette.slice(-1)[0] !== newPalette.slice(-1)[0],
      date !== newDate
    ];

    if (valid.includes(true)) {
      return true;
    }

    return false;
  }

  setLightningsData() {
    const { settings, map, interpolation, tile, strikes } = this.props;
    const pSize = Number(settings.pointSize);
    const wholeRange = Math.round((moment().valueOf() - moment(this.props.startDate, RADAR_FORMAT).valueOf()) / 60000);
    const style = {
      variables: {
        minDistance: 0,
        maxDistance: wholeRange - 1
      },
      filter: ['between', ['get', 'distance'], ['var', 'minDistance'], ['var', 'maxDistance']],
      symbol: {
        symbolType: 'circle',
        size: pSize,
        color: ['interpolate', ['linear'], ['get', 'distance'], 2, interpolation[0], wholeRange, interpolation[1]],
        rotateWithView: true
      }
    };

    const styleNew = {
      symbol: {
        symbolType: 'circle',
        size: pSize,
        color: '#fff',
        rotateWithView: true
      }
    };

    const loc = window.location;

    const vectorSource = new VectorSource({
      url: `${loc.protocol}//${loc.host}/data/lightnings.geojson?v${Date.now()}`,
      format: new GeoJSON(),
      wrapX: true
    });

    const newLightningsVectorSource = new VectorSource({
      wrapX: true
    });

    this.lightningsLayer = new WebGLPointsLayer({
      source: vectorSource,
      style: style
    });

    this.lightningsLayer.meta = {
      UIType: LAYER_DETECTOR
    };

    map.addLayer(this.lightningsLayer);

    if (this.state.animation === true) {
      this.newLightningsLayer = new WebGLPointsLayer({
        source: newLightningsVectorSource,
        style: styleNew,
        className: LAYER_DETECTOR
      });

      this.newLightningsLayer.meta = {
        UIType: LAYER_DETECTOR
      };

      map.addLayer(this.newLightningsLayer);

      const lastStrike = strikes.range[1];
      const then = withTimezone(lastStrike, LIGHTNINGS_DATEFORMAT);
      const now = moment().format(LIGHTNINGS_DATEFORMAT);
      const maxPeriodOffset = 500;

      const periodOffset = getTimeDiff(now, then);
      const updateTime = withTimezone(strikes.updateTime, LIGHTNINGS_DATEFORMAT);
      const updateOffset = getTimeDiff(updateTime, now) + 5;
      this.clearTimeouts();
      if (periodOffset <= maxPeriodOffset) {
        strikes.data.forEach((item, i) => {
          const date = withTimezone(item[1], LIGHTNINGS_DATEFORMAT);
          const offset = getTimeDiff(then, date);
          if (offset < 60 + updateOffset) {
            this.lightningsTimeouts.push(
              global.setTimeout(() => {
                strike({
                  source: newLightningsVectorSource,
                  tileLayer: tile,
                  map,
                  distance: item[2],
                  x: item[0][1],
                  y: item[0][0]
                });
              }, (60 + offset) * 1000)
            );
          }
        });
      }
    }
  }

  clearTimeouts = () => {
    this.lightningsTimeouts.forEach(item => {
      clearTimeout(item);
    });
  };

  componentDidMount() {
    const self = this;
    global.onblur = function(event) {
      self.clearTimeouts();
      self.setState({ animation: false });
    };
    global.onfocus = function(event) {
      self.removeLightningsLayers();
      self.setLightningsData();
      self.setState({ animation: true });
    };
  }

  componentWillUnmount() {
    this.clearTimeouts();
  }

  removeLightningsLayers() {
    const { map } = this.props;
    removeLayer(LAYER_DETECTOR, map);
    removeLayerByClassName(LAYER_DETECTOR, map);
  }

  render() {
    const { startDate, settings, map, date } = this.props;
    this.removeLightningsLayers();
    !date && this.setLightningsData();
    map && setLayerOpacity(settings.opacity, LAYER_DETECTOR, map);
    return !date && startDate ? (
      <Legend>
        <LegendInner colors={this.colorRange}>
          <LegendBadge>
            <Icon name="bolt fas" />
            &nbsp; {getHour(startDate)} - {getHour(moment())}
          </LegendBadge>
        </LegendInner>
      </Legend>
    ) : null;
  }
}

export default Lightnings;
